<div class="sx-guide">
 
  <div >
    <div class="sx-guide__content">
      <div  class="sx-guide__image-panel">
        <img class="sx-guide__image" src="{{ loginMessage.image }}" *ngIf="loginMessage.image">
      </div>
      <div class="sx-guide__text">
        <h3 *ngIf="loginMessage.heading" [innerHTML]="loginMessage.heading"></h3>
        <div *ngIf="loginMessage.mainText" [innerHTML]="loginMessage.mainText | safeHtml" appRouterLink></div>
      </div>
    </div>
  </div>

  <div class="sx-guide__button-panel sx-guide__button-panel--center">

    <button mat-button class="sx-button sx-button--magenta sx-button--wide sx-guide__cancel-button" (click)="onCancel()" id="login_message_close_btn">
      {{ 'core.help.guides.close' | translate }}
    </button>

  </div>
</div>
